import Image from "next/image";
import React from "react";
import Button from "../EventButtons/Button";
import Headline from "@/partials/elements/Headline";
import Description from "@/partials/elements/Description";
import { IoGiftOutline } from "react-icons/io5";
import GridSection from "@/partials/sections/Section/GridSection";
import FlexSection from "@/partials/sections/Section/FlexSection";

export default function Membership() {
  return (
    <GridSection extraClass="text-start w-full grid-rows-1">
      <FlexSection extraClass={"flex-col gap-5"}>
        <FlexSection extraClass=" items-center justify-start gap-4 ">
          <figure className="p-3 border rounded-md hover:bg-primary group duration-300">
            <IoGiftOutline
              size={30}
              className=" cursor-pointer group-hover:text-white"
            />
          </figure>
          <Headline
            text={"Membership"}
            extraClass="text-2xl md:text-[28px] text-[#000]"
          />
        </FlexSection>
        <Description
          text={
            " Aim to provide a holistic suite of benefits and support services to enhance collaboration and synergy within our community. Become a valued member and stay updated with the latest developments, ongoing events, and upcoming initiatives in the Plastic Surgeon community. Join us as we strive to foster a culture of knowledge-sharing, growth, and collective progress."
          }
        />
      </FlexSection>
      <FlexSection extraClass={"justify-center md:justify-start"}>
        <Button text="Become a Member" link={"/member"} />
      </FlexSection>
    </GridSection>
  );
}
